module.exports = __webpack_public_path__ + "img/header.e77b23ec.png";